const random = () => {
  return Math.floor(Math.random() * 10000000000);
};

export default random;
